// removed by extract-text-webpack-plugin
module.exports = {"root":"App__root___18MbG","app":"App__app___2iKXm"};


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 515
// module chunks = 0